const Styles = (theme) => {
   return {
      html: {
         '@media(min-width: 1440px)': {
            fontSize: '16px',
         },

         '@media(min-width: 1921px)': {
            fontSize: '20px',
         },
      },

      'html,body': {
         padding: 0,
         margin: 0,
         boxSizing: 'border-box',
      },
      '.content-container': {
         marginTop: '150px',
         padding: '10px 60px',

         '@media (max-width: 768px)': {
            marginTop: '100px',
            padding: '10px 20px',
         },
      },

      '*': {
         boxSizing: 'border-box',
         borderColor: theme.colors.borderColor.color1,
      },

      body: {
         backgroundColor: theme.colors.bodyBgColor,
         color: theme.colors.color.color1,
         fontFamily: `'Open Sans', sans-serif`,
         fontSize: '1rem',
      },

      '.color-1': {
         '&, *': {
            color: theme.colors.color.color1,
         },
      },

      '.color-2': {
         '&, *': {
            color: theme.colors.color.color2,
         },
      },

      '.color-3': {
         '&, *': {
            color: theme.colors.color.color3,
         },
      },

      '.color-primary': {
         '&, *': {
            color: theme.colors.palatte.primary,
         },
      },
   };
};

export default Styles;
